// extracted by mini-css-extract-plugin
module.exports = {"container":"Newsletter_container__1jVQt","subscribe":"Newsletter_subscribe__3IJmM"};